@if (loadingRoute) {
<div class="absolute top-0 left-0 right-0 z-[1000]">
  <mat-progress-bar color="primary" mode="indeterminate" />
</div>
}
<ngx-loading-bar color="#02607f" height="3px" />
<router-outlet #o="outlet" />
